import { useState, useEffect } from 'react'
import { useAuthStore } from '../stores'
import getSubscription from './subscriptions'

export interface ProStatus {
  isPro: boolean
  loading: boolean
  role: string | null
}

export function useProStatus(): ProStatus {
  const { user } = useAuthStore()
  const [isPro, setIsPro] = useState(false)
  const [loading, setLoading] = useState(true)
  const [role, setRole] = useState<string | null>(null)

  useEffect(() => {
    let mounted = true
    async function check() {
      try {
        const sub = await getSubscription()
        if (!mounted) return
        const active = !!(sub && (sub.status === 'active' || sub.active))
        setIsPro(active)
        setRole(sub?.role || null)
      } catch {
        if (mounted) setIsPro(false)
      } finally {
        if (mounted) setLoading(false)
      }
    }
    check()
    return () => { mounted = false }
  }, [user])

  return { isPro, loading, role }
}

export const FREE_LIMITS = {
  videos: 1,
  photos: 5,
  achievements: 3,
  documents: 1,
  conversations: 1,
} as const

export function useFeatureLimit(feature: keyof typeof FREE_LIMITS, currentCount: number): { allowed: boolean; limit: number; isPro: boolean; loading: boolean } {
  const { isPro, loading } = useProStatus()
  const limit = isPro ? Infinity : FREE_LIMITS[feature]
  return { allowed: loading || currentCount < limit, limit: isPro ? 0 : FREE_LIMITS[feature], isPro, loading }
}
